import { render, staticRenderFns } from "./yhubReportBarChart.vue?vue&type=template&id=a21a74be"
import script from "./yhubReportBarChart.vue?vue&type=script&lang=js"
export * from "./yhubReportBarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports